import { render } from "./ApplicationMGAgComponent.vue?vue&type=template&id=44e76d8d&scoped=true&ts=true"
import script from "./ApplicationMGAgComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationMGAgComponent.vue?vue&type=script&lang=ts"

import "./ApplicationMGAgComponent.vue?vue&type=style&index=0&id=44e76d8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e76d8d"]])

export default __exports__